import React, { MutableRefObject, RefObject, useEffect, useRef } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import { useBoolean } from 'react-use';
interface IProps {
    className?: string;
    children: React.ReactNode;
    clickOutsideToHide?: boolean;
    isShow: boolean;
    fromBottom?: boolean;
    onClose: () => void;
}

export function Modal({
    className,
    children,
    clickOutsideToHide,
    isShow,
    onClose,
    fromBottom,
}: IProps) {
    const modalRef: MutableRefObject<any> = useRef<RefObject<any>>(null);
    const [animation, setAnimation] = useBoolean(false);
    const handleDoubleClick = (evt: React.MouseEvent) => {
        evt.preventDefault();
        evt.stopPropagation();
    };

    useEffect(() => {
        setTimeout(() => setAnimation(true), 50);
        return () => setAnimation(false);
    }, [isShow]);


    const handleClick = (evt: React.MouseEvent) => {
        evt.stopPropagation();
        if (!modalRef.current.contains(evt.target) && clickOutsideToHide) {
            onClose();
        }
    };

    return (
        <div
            onDoubleClick={handleDoubleClick}
            onClick={handleClick}
            className={classnames(styles['modal'], className, {
                [styles['is-active']]: isShow,
                [styles['is-bottom']]: fromBottom,
                [styles['show-animation']]: animation && isShow,
            })}
        >
            <div
                ref={modalRef}
                role="presentation"
                className={styles['modal-background']}
            >
                <div className={styles['modal-content']}>{children}</div>
            </div>
        </div>
    );
}

export default Modal;
